export default {
  UPGRADE_REQUIRED: 402, // 402: Payment Required
};